import { useCallback, useMemo, useState } from 'react';
import * as api from '../api';
import PageHeader from '../components/ui/PageHeader';
import DataTable from '../components/ui/DataTable';
import ErrorMessage from '../components/ui/ErrorMessage';
import { formatDateTime } from '../utils/formatDate';
import { usePaginatedList } from '../hooks/usePaginatedList';
import './CrudPage.scss';

const STATUS_OPTIONS = [
    { value: 'pending', label: 'Ожидает' },
    { value: 'succeeded', label: 'Успешен' },
    { value: 'canceled', label: 'Отменён' },
];

export default function PaymentsPage() {
    const fetchList = useCallback(
        (params) => api.listResource('payments', params),
        [],
    );
    const {
        items, total, offset, limit, loading, error, setOffset, reload,
    } = usePaginatedList(fetchList);

    const [statusError, setStatusError] = useState('');
    const [updatingId, setUpdatingId] = useState(null);

    const handleStatusChange = useCallback(async (row, nextStatus) => {
        if (nextStatus === row.status) return;
        setUpdatingId(row.id);
        setStatusError('');
        try {
            await api.updateResource('payments', row.id, { status: nextStatus });
            reload();
        } catch (err) {
            setStatusError(err.message || 'Не удалось изменить статус');
        } finally {
            setUpdatingId(null);
        }
    }, [reload]);

    const columns = useMemo(() => [
        { key: 'id', title: '№', width: 60 },
        { key: 'customer_id', title: 'ID', width: 90 },
        { key: 'customer_login', title: 'Логин' },
        { key: 'subscription_id', title: 'Подписка' },
        {
            key: 'status',
            title: 'Статус',
            render: (value, row) => (
                <select
                    className="cell-select"
                    value={value}
                    disabled={updatingId === row.id}
                    onChange={(e) => handleStatusChange(row, e.target.value)}
                >
                    {STATUS_OPTIONS.map(({ value: v, label }) => (
                        <option key={v} value={v}>{label}</option>
                    ))}
                </select>
            ),
        },
        { key: 'payment_system', title: 'Система' },
        { key: 'cash_amount', title: 'Сумма' },
        { key: 'points_spent', title: 'Баллы' },
        { key: 'promo_code', title: 'Промокод' },
        {
            key: 'created_at',
            title: 'Создан',
            render: (v) => formatDateTime(v),
        },
    ], [updatingId, handleStatusChange]);

    return (
        <div className="crud-page">
            <PageHeader title="Платежи" subtitle="История и статусы платежей" />

            <ErrorMessage message={error || statusError} onRetry={reload} />

            <DataTable
                columns={columns}
                rows={items}
                loading={loading}
                pagination={{ total, limit, offset, onPageChange: setOffset }}
            />
        </div>
    );
}
